export const ctx = {
  metallic: require.context(
    "../assets/images/materials/hull/metallic",
    false,
    /\.png$/,
  ),
  unicolors: require.context(
    "../assets/images/materials/hull/uni",
    false,
    /\.png$/,
  ),
  teak_colors: require.context(
    "../assets/images/materials/teak",
    false,
    /\.png$/,
  ),
  teak_natural: require.context(
    "../assets/images/materials/teak",
    false,
    /\.png$/,
  ),
  fabrics_colors: require.context(
    "../assets/images/materials/fabrics",
    false,
    /\.png$/,
  ),
} as const;

export function withImageSrc(items: any[]) {
  return items.map((it) => {
    // @ts-ignore
    const loader: __WebpackModuleApi.RequireContext = ctx[it.group];
    let src: string | undefined;
    try {
      src = loader(`./${it.filename}`); // must match exact file name
    } catch {
      src = undefined; // file missing/misspelled
    }
    return { ...it, src };
  });
}
